export const getGraphQLID = (id, resource) => `gid://shopify/${resource}/${id}`;
